import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";

// Import Context
// import { ItemFilterContext } from "../contexts/ItemFilterContext";

import Box from "@mui/material/Box";
// import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
// import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

export const ItemTableFilterBar = ({ itemFilter, setItemFilter }) => {
  // const { setItemFilter } = useContext(ItemFilterContext);
  const [currentSearchValue, setCurrentSearchValue] = useState(
    itemFilter?.search || "",
  );
  const queryClient = useQueryClient();

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setItemFilter((prevState) => ({
      ...prevState,
      search: currentSearchValue,
    }));
    invalidateQuery();
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setItemFilter((prevState) => ({
      ...prevState,
      search: "",
    }));
    invalidateQuery();
  };

  const invalidateQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ["itemListState"],
      exact: true,
    });
  };

  return (
    <Box component="form" onSubmit={handleSearchSumbit}>
      <TextField
        onChange={handleSearchChange}
        value={currentSearchValue}
        label="Search.."
        id="item-table-search"
        name="Search"
        variant="outlined"
        size="small"
        fullWidth
        slotProps={{
          input: {
            endAdornment: (
              <>
                <InputAdornment
                  position="end"
                  sx={{
                    visibility: currentSearchValue ? "visible" : "hidden",
                  }}
                >
                  <IconButton onClick={handleSearchClear} color="error">
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
                <InputAdornment position="end">
                  <IconButton type="submit">
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              </>
            ),
          },
        }}
      />
    </Box>
  );
};
